import React from 'react';
import './Billing.css'; // スタイルシートをインポート

function Billing({ framePrice, couponInfo }) {
  const originalAmount = 500 + framePrice;
  const discountAmount = couponInfo?.discountAmount || 0;
  const finalAmount = couponInfo?.finalAmount ?? originalAmount;

  return (
    <div className="billing">
      <ul className="billing_list">
        <li className="flex billing_total">
          <p>合計金額</p>
          <p>
            {finalAmount} 円
            <span className="billing_total_tax">（税込）</span>
          </p>
        </li>
        <li className="flex billing_standard">
          <p>ダウンロード料金</p>
          <p>500円</p>
        </li>
        <li className="flex billing_add">
          <p>フレーム追加料金</p>
          <p>{framePrice}円</p>
        </li>
        {couponInfo && (
          <li className="flex billing_discount">
            <p>クーポン割引 ({couponInfo.discountDisplay})</p>
            <p>-{discountAmount}円</p>
          </li>
        )}
      </ul>
    </div>
  );
}

export default Billing;
